
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, inject, DOCUMENT } from '@angular/core';
import { environment } from '../../../../environments/environment';

/** Body class that pushes the fixed header and sidebar down by the banner's height. */
export const QA_ENVIRONMENT_BODY_CLASS = 'qa-environment';

@Component({
  selector: 'ngx-qa-banner',
  imports: [],
  templateUrl: './qa-banner.component.html',
  styleUrl: './qa-banner.component.scss',
  // Unencapsulated so the offset rules can reach Nebular's fixed header and sidebar, which live
  // outside this component; every rule is scoped under the QA body class, so other builds are untouched.
  encapsulation: ViewEncapsulation.None,
})
/**
 * Full-width strip at the top of every backoffice page on the QA build (#881), so testers always
 * know they are not in production and every screenshot they attach shows it. Not dismissable.
 */
export class QaBannerComponent implements OnInit, OnDestroy {
  /**
   * Environment the build was made for. Keyed on the name rather than environment.production
   * because LocalDev and Docker also set production: true.
   */
  @Input() environmentName = environment.name;

  private readonly document = inject(DOCUMENT);

  /** True only on the QA build. */
  get visible(): boolean {
    return this.environmentName === 'QA';
  }

  /** Adds the body class that makes room for the banner above the fixed header. */
  ngOnInit(): void {
    if (this.visible) this.document.body.classList.add(QA_ENVIRONMENT_BODY_CLASS);
  }

  /** Removes the body class again so a destroyed banner leaves no gap behind. */
  ngOnDestroy(): void {
    this.document.body.classList.remove(QA_ENVIRONMENT_BODY_CLASS);
  }
}
